import * as React from 'react';
import { connect } from 'react-redux';

import { IBreadCrumb } from '../../types/bread_crumb';
import { IUser } from '../../types/user';
import { IConfig } from '../../types/config';
import { Nav as NavComponent } from '../../components/nav/nav';
import { refreshScroll } from '../../reducers/modules/scroll/scroll';
import { toggleSearch, toggleRegions } from '../../reducers/modules/config/config';
import { TDeviceType } from "@cian/ui-kit";
import { IMenuRubrics, IMenuRubricsState } from '../../reducers/modules/rubrics_menu/rubrics_menu';
import { TDispatch } from "../../types/redux";

interface IProps {
  user: IUser;
  config: IConfig;
  breadCrumb: IBreadCrumb;
  dispatch: TDispatch;
  deviceType: TDeviceType;
  menuRubrics: IMenuRubrics[];
}

const navMapping: { [key: string]: string; } = {
  interview: 'Интервью',
  review: 'Обзор',
  analytics: 'Аналитика',
  market: 'Новости рынка',
  company: 'Новости компании',
  'q-specialist': 'Специалист–специалисту',
  'q-market_trend': 'Тенденции рынка',
  'q-city_realty': 'Городская недвижимость',
  'q-commerce_realty': 'Коммерческая недвижимость',
  'q-country_realty': 'Загородная недвижимость',
  'q-foreign_realty': 'Зарубежная недвижимость',
  'q-hypothec': 'Ипотека',
  'b-specialist': 'Специалист–специалисту',
  'b-market_trend': 'Тенденции рынка',
  '/add-blog': 'Добавить запись',
  '/moi-blog': 'Мой блог',
  '/add-vopros': 'Задать вопрос',
  '/reyting-rieltorov': 'Журнал',
};

class NavClass extends React.Component<IProps> {
  public render() {
    return (
      <NavComponent
        deviceType={this.props.deviceType}
        activeItem={this.getActiveItem()}
        currentUser={this.props.user}
        toggleSearch={(open: boolean) => this.props.dispatch(toggleSearch(open))}
        toggleRegions={(open: boolean) => this.props.dispatch(toggleRegions(open))}
        regionName={this.props.config.regionName}
        refreshScroll={this.refreshScroll}
        navItems={this.props.menuRubrics}
      />
    );
  }

  protected refreshScroll = () => {
    this.props.dispatch(refreshScroll());
  }

  private getActiveItem() {
    const { breadCrumb } = this.props;
    const navKey = (!!breadCrumb.path) ? breadCrumb.path.slice(-1).pop() : undefined;

    return (!!navKey) ? navMapping[navKey.path] : undefined;
  }
}

interface IState {
  breadCrumb: IBreadCrumb;
  user: IUser;
  config: IConfig;
  deviceType: TDeviceType;
  menuRubrics: IMenuRubricsState;
}
const mapStateToProps = (state: IState) => ({ ...state, menuRubrics: state.menuRubrics.items });
export const Nav = connect(mapStateToProps)(NavClass);
